
import { Endereco } from '@/models/endereco_model';

export default {
  name: 'ItemListaEnderecos',
  props: {
    index: {
      type: Number,
      required: true
    },
    endereco: {
      type: Endereco,
      required: true
    },
    startExpanded: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showMore: false,
  }),
  computed: {
    logradouro(): string {
      const numero = this.endereco?.numero ? `nº ${this.endereco?.numero}` : '';
      const logradouro = this.endereco?.logradouro ?? '';
      const separador = numero && logradouro ? ', ' : '';

      return logradouro + separador + numero;
    }
  },
  methods: {
    editarEndereco(endereco: Endereco, index: number) {
      this.showMore = true;
      this.$emit('editarEndereco', endereco, index);
    },
    excluirEndereco(endereco: Endereco, index: number) {
      this.$emit('excluirEndereco', endereco, index);
    },
    showInformacoesEndereco() {
      this.$alert({
          tipo: 'info',
          message: `O endereço cadastrado como <strong>Principal</strong> 
            será o utilizado em seus movimentos no sistema. Ex:
            NF-e, NFC-e, NFS-e.`
      });
    }
  },
  mounted() {
    this.showMore = this.startExpanded;
  }
}
